import { disableThumbLogs } from 'reactApp/appHelpers/featuresHelpers/features/thumbLogs';
import { sendDwh } from 'reactApp/utils/ga';

export const enum NoThumbReasons {
    tooSmall = 'small',
    noSize = 'no-size',
    notPreviewable = 'no-preview',
    tooBig = 'big',
}

interface SendThumbDwhParams {
    action: string;
    dwh: Record<string, any>;
    reason?: NoThumbReasons;
    dwh_enabled?: boolean;
    dwh_enabled_fields?: string[][];
}

export const sendThumbDwh = ({ reason, action, dwh, dwh_enabled = false, dwh_enabled_fields }: SendThumbDwhParams) => {
    if (disableThumbLogs) {
        return;
    }

    sendDwh({
        eventCategory: 'thumb',
        action,
        dwh_enabled,
        dwh_enabled_fields,
        dwhData: {
            ...dwh,
            reason,
        },
    });
};
